import { useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';
import { Loading } from '@/components/shared/Loading';
import { FuncionarioItem } from '@/components/PagesComponents/Comunidade/FuncionarioItem';

interface IFuncionario extends IUsuario {
}

const Funcionarios = () => {
    const [funcionarios, setFuncionarios] = useState<IFuncionario[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {

        const getFuncionarios = async () => {
            setIsLoading(true);
            const url = '/user/register/allUser/Funcionarios';

            await api.get(url)
                .then(response => {
                    setFuncionarios(response.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    setIsLoading(false);
                })
        }

        getFuncionarios();

    }, []);

    return (
        <>
            <h1>Funcionários</h1>

            {isLoading ? (
                <Loading color='primary' />
            ) : (
                <>
                    {funcionarios.map(funcionario => {
                        if (funcionario._id != '660424dd9557bf9242071388') {
                            return (
                                <FuncionarioItem key={funcionario._id} data={funcionario} />
                            )
                        }

                    })}
                </>
            )}
        </>
    );
}

export { Funcionarios };